import {Button} from '@wandb/weave/components';
import {Icon} from '@wandb/weave/components/Icon';
import {clsx} from 'clsx';
import React from 'react';

const ITEM_CLASSES = clsx(
  'flex flex-row gap-4 items-center',
  'px-8 py-4',
  'rounded-sm border border-transparent'
);
const SELECTED_CLASSES = clsx('bg-wb-accent-bg/30 text-wb-accent-text');
const HIGHLIGHTED_CLASSES = clsx('bg-moon-100 dark:bg-moon-850');

const LABEL_CLASSES = clsx('truncate');

const ICON_CLASSES = clsx('block ml-auto');

type InlineComboboxItemProps<ItemType> = {
  disabled?: boolean;
  highlighted: boolean;
  item: ItemType;
  itemToString: (item: ItemType) => string;
  selected: boolean;
  disabledItemMessage?: string | undefined;
};

export function InlineComboboxItem<ItemType>({
  disabled,
  highlighted,
  item,
  itemToString,
  selected,
  disabledItemMessage,
}: InlineComboboxItemProps<ItemType>) {
  return (
    <div
      className={clsx(ITEM_CLASSES, {
        [HIGHLIGHTED_CLASSES]: highlighted,
        [SELECTED_CLASSES]: selected,
        'cursor-default': disabled,
        'cursor-pointer': !disabled,
        'text-wb-text-tertiary': disabled,
      })}>
      <div className={clsx(LABEL_CLASSES)}>{itemToString(item)}</div>
      {disabled ? (
        <div className="absolute right-2 top-1/2 -translate-y-1/2">
          <Button variant="ghost" icon="info" tooltip={disabledItemMessage} />
        </div>
      ) : null}
      {selected ? <Icon name="checkmark" className={ICON_CLASSES} /> : null}
    </div>
  );
}

export function InlineComboboxItemVirtualized() {}
